import { Form, Input, Table } from 'antd'
import qs from 'qs'
import { FC, useMemo } from 'react'
import styled from 'styled-components'
import PageLayout from '../../components/page-layout/page-layout'
import TableWrapper from '../../components/table-wrapper/table-wrapper'
import useFiltersForm from '../../hooks/forms/use-filters-form'
import useEndpointQueryParams, {
    DeserializeFilters,
} from '../../hooks/table-pages/use-endpoint-query-parameters'
import useTablePagination from '../../hooks/table-pages/use-table-pagination'
import { useGetPantonesQuery } from '../../store/api/pantones-api'
import { EndpointQueryParameters } from '../../types/strapi/strapi'
import { defaultParams } from './constants/default-params'
import { getPaintsColumns } from './constants/get-paints-columns'

const SearchForm = styled(Form)`
    margin-bottom: 16px;
`

const SearchInput = styled(Input.Search)`
    width: 300px;
`

const deserializeFilters: DeserializeFilters = filtersString => {
    const { name } = qs.parse(filtersString)
    return typeof name === 'string' && name.trim()
        ? { name: { $containsi: name.trim() } }
        : undefined
}

/** Справочник рецептов пантонов (только просмотр). */
const PaintsPage: FC = () => {
    const params = useEndpointQueryParams({ deserializeFilters })
    const { form, onSearch } = useFiltersForm()

    const queryArg = useMemo<EndpointQueryParameters>(
        () => ({ ...defaultParams, ...params }),
        [params]
    )

    const { data, isFetching } = useGetPantonesQuery(queryArg)
    const pagination = useTablePagination(queryArg, data)
    const pantones = data?.data || []
    const colorantsCount = Math.max(1, ...pantones.map(item => item.colorants?.length ?? 0))
    const columns = useMemo(() => getPaintsColumns(colorantsCount), [colorantsCount])

    return (
        <PageLayout title='Краски'>
            <SearchForm form={form}>
                <Form.Item name='name' noStyle>
                    <SearchInput
                        placeholder='Поиск по наименованию'
                        allowClear
                        onChange={onSearch}
                    />
                </Form.Item>
            </SearchForm>
            <TableWrapper>
                <Table
                    rowKey='documentId'
                    columns={columns}
                    dataSource={pantones}
                    loading={isFetching}
                    pagination={pagination}
                    scroll={{ x: 'max-content' }}
                    bordered
                />
            </TableWrapper>
        </PageLayout>
    )
}

export default PaintsPage
